import { View, Text, StyleSheet, TouchableOpacity, Linking } from "react-native";
import * as Clipboard from 'expo-clipboard';
import { FontAwesome } from '@expo/vector-icons';
import * as React from "react";

export default function Locations(props) {
    const copyToClipboard = async (loc) => {
        await Clipboard.setStringAsync(loc.address.toString().replace(/\t/g, ', '));
    };
    return (
        <View>
            {props.locations.map((loc) => {
                return (
                    <View style={styles.locationContainer} key={"location".concat(loc.id)}>
                        <TouchableOpacity
                            style={styles.copyIcon}
                            activeOpacity={0.5}
                            onPress={() => { copyToClipboard(loc) }}
                        >
                            <FontAwesome name="copy" size={16} color="#4EBDEF" style={styles.copyIconStyle} />
                        </TouchableOpacity>
                        <TouchableOpacity
                            style={styles.addressText}
                            activeOpacity={0.5}
                            onPress={() => Linking.openURL('https://www.google.com/maps/dir/Current+Location/' + loc.address.toString().replace(/\t/g, ', '))}
                        >
                            <Text style={styles.textLocationStyle}>{loc.address.toString().replace(/\t/g, ', ')}</Text>
                        </TouchableOpacity>
                    </View>
                )
            })}
        </View>
    )
}
const styles = StyleSheet.create({
    locationContainer: {
        lineHeight: 25,
        flexDirection: "row",
        alignItems: "center",
        paddingBottom: 15,
    },
    copyIconStyle: {
        marginRight: 5,
        paddingBottom: 10
    },
    textLocationStyle: {
        fontFamily: "montserrat-regular",
        fontSize: 13,
        textAlign: "left",
        lineHeight: 20,
    },
    copyIcon: {
        paddingRight: 20,
        paddingLeft:10,
    },
    addressText: {
        flex: 1,
        fontFamily: "montserrat-regular",
        fontSize: 13,
        textAlign: "left",
        lineHeight: 20,
      },
})